const fieldTrialConsoleEnabled =
  process.env.REACT_APP_FIELD_TRIAL_CONSOLE !== "false";

export const consoleFeatures = {
  showDeviceName: !fieldTrialConsoleEnabled,
  showSharedKeyVersion: !fieldTrialConsoleEnabled,
  enableMobileAppPage: !fieldTrialConsoleEnabled,
  enableDefaultsPage: !fieldTrialConsoleEnabled,
};
